import { useMemo } from "react";
import { useFeatureFlag } from "../feature-flag/useFeatureFlag";

export interface DefaultsArrItem {
  name: boolean | undefined;
  label: string;
}

interface useTransformerFormDefaultsProps {
  numberOfPhasesIsDefault?: boolean;
  nameplateRatingIsDefault?: boolean;
  fuseSelectionIsDefault?: boolean;
  hvFaultLevelIsDefault?: boolean;
  xrRatioIsDefault?: boolean;
  primaryVoltagekVIsDefault?: boolean;
}

export function useTransformerFormDefaults({
  numberOfPhasesIsDefault,
  nameplateRatingIsDefault,
  fuseSelectionIsDefault,
  hvFaultLevelIsDefault,
  xrRatioIsDefault,
  primaryVoltagekVIsDefault,
}: useTransformerFormDefaultsProps): DefaultsArrItem[] {
  const primaryVoltageEnabled = useFeatureFlag("TransformerPrimaryVoltageEnabled");

  return useMemo(() => {
    const arr: DefaultsArrItem[] = [
      { name: numberOfPhasesIsDefault, label: "numberOfPhases" },
      { name: nameplateRatingIsDefault, label: "nameplateRating" },
      { name: fuseSelectionIsDefault, label: "fuseSelection" },
      { name: hvFaultLevelIsDefault, label: "hvFaultLevel" },
      { name: xrRatioIsDefault, label: "xrRatio" },
    ];

    if (primaryVoltageEnabled) {
      arr.push({ name: primaryVoltagekVIsDefault, label: "primaryVoltagekV" });
    }

    return arr;
  }, [
    numberOfPhasesIsDefault,
    nameplateRatingIsDefault,
    fuseSelectionIsDefault,
    hvFaultLevelIsDefault,
    xrRatioIsDefault,
    primaryVoltagekVIsDefault,
    primaryVoltageEnabled,
  ]);
}
